import React, { useState, useEffect } from "react";
import printJS from "print-js";
import {
  IconDeviceFloppy,
  IconGardenCart,
  IconMinus,
  IconPlus,
  IconTrash,
  IconBugOff,
  // IconRefresh,
  IconCash,
  IconPrinter,
} from "@tabler/icons-react";
import Swal from "sweetalert2";
import { Button, Form, Modal, Alert, Badge } from "react-bootstrap";
import { usePaymentMethod } from "contexts/v1/masterData/PaymentMethodContext";
import { useCreateData, useUpdateData } from "hooks/useApiHooks";
// import { useFormChangeHandler } from "hooks/useFormChangeHandler";
import { useSubmitHandler } from "hooks/useSubmitHandler";
import { formatPrice } from "utils/utils";
import {
  KUBER_LOGO_BASE64,
} from "constants/kuber-logo-base64";
import PermissionMiddleware from "middleware/PermissionMiddleware";

const CartSummary = ({ cartItems, setCart, onSuccess, onError }) => {
  const { paymentMethods } = usePaymentMethod();

  const API_URL = "/transaction";
  const [savedBills, setSavedBills] = useState([]);
  const [activeBillId, setActiveBillId] = useState(null);
  console.log("activeBillId cartItems", activeBillId);
  const [paymentMethod, setPaymentMethod] = useState("");
  // Menyaring metode pembayaran yang hanya menunjukkan show_pos = true
  const filteredPaymentMethods = paymentMethods.data.filter(
    (method) => method.show_pos === true
  );
  const [cashPaid, setCashPaid] = useState(""); // ✅ Uang yang dibayarkan pelanggan
  const [change, setChange] = useState(null); // ✅ Kembalian atau kekurangan
  const [showModal, setShowModal] = useState(false); // Untuk mengontrol visibilitas modal
  const closeModal = () => setShowModal(false);

  // 🎯 Enhanced Features dari cash_drawer_demo
  const [debugLogs, setDebugLogs] = useState([]);
  const [statusMessages, setStatusMessages] = useState([]);
  const [showDebugLog, setShowDebugLog] = useState(false);
  const [androidHandlerStatus, setAndroidHandlerStatus] = useState(false);
  const [taxRate, setTaxRate] = useState(0);

  useEffect(() => {
    // filterOptions show_pos
    if (!paymentMethod) {
      setTaxRate(0);
      return;
    }

    const selectedMethod = paymentMethods.data.find(
      (pm) => pm.name === paymentMethod
    );

    if (selectedMethod) {
      const rawTax = parseFloat(selectedMethod.tax);
      // Konversi dari persentase (3.00) ke decimal (0.03)
      const taxDecimal = rawTax / 100;
      setTaxRate(isNaN(taxDecimal) ? 0 : taxDecimal);
    } else {
      setTaxRate(0);
    }
  }, [paymentMethod, paymentMethods]);

  const subtotal = cartItems.reduce(
    (total, item) => total + item.price * item.quantity,
    0
  );
  
  // 1. Hitung pajak berdasarkan masing-masing item produk
  const productTaxAmount = cartItems.reduce(
    (total, item) => {
      const itemTax = (parseFloat(item.tax_percent) || 0) / 100;
      return total + (item.price * item.quantity * itemTax);
    },
    0
  );

  // 2. Hitung pajak/biaya berdasarkan metode pembayaran (service charge / fee)
  // Dihitung dari (Subtotal + Pajak Produk) sesuai permintaan user
  const paymentTaxAmount = (subtotal + productTaxAmount) * taxRate;

  // Total akhir gabungan
  const grandTotal = subtotal + productTaxAmount + paymentTaxAmount;

  // const tax = subtotal * taxRate; // misal taxRate = 0.1 (10%)
  // const total = subtotal + tax;

  const [formData, setFormData] = useState({
    payment_method_id: "",
    notes: "",
    items: [],
    location: "", // Tambahkan location field
  });

  const isUpdateMode = !!cartItems;

  // 🎯 Enhanced Functions dari cash_drawer_demo
  const addDebugLog = (message) => {
    const timestamp = new Date().toLocaleTimeString();
    const logEntry = `[${timestamp}] ${message}`;
    setDebugLogs((prev) => [...prev.slice(-49), logEntry]); // Keep only last 50 logs
    console.log("Kuber POS:", message);
  };

  const showStatusMessage = (message, type = "info") => {
    const newMessage = {
      id: Date.now(),
      message,
      type,
      timestamp: new Date().toLocaleTimeString(),
    };
    setStatusMessages((prev) => [...prev, newMessage]);

    // Auto remove setelah 5 detik
    setTimeout(() => {
      setStatusMessages((prev) =>
        prev.filter((msg) => msg.id !== newMessage.id)
      );
    }, 5000);
  };

  const checkAndroidHandler = () => {
    const isAvailable = typeof window.AndroidPrintHandler !== "undefined";
    setAndroidHandlerStatus(isAvailable);

    if (isAvailable) {
      addDebugLog("AndroidPrintHandler is available");
      const methods = Object.getOwnPropertyNames(window.AndroidPrintHandler);
      addDebugLog("Available methods: " + methods.join(", "));
    } else {
      addDebugLog("AndroidPrintHandler is NOT available");
    }

    return isAvailable;
  };

  const openCashDrawer = () => {
    addDebugLog("Opening cash drawer...");
    if (typeof window.AndroidPrintHandler !== "undefined") {
      showStatusMessage("🔄 Membuka cash drawer...", "info");
      window.AndroidPrintHandler.openCashDrawer();
      addDebugLog("Cash drawer command sent");
    } else {
      showStatusMessage("❌ AndroidPrintHandler tidak tersedia", "error");
      addDebugLog("AndroidPrintHandler not available");
    }
  };

  // const refreshPwa = () => {
  //   addDebugLog("Refreshing PWA...");
  //   if (typeof window.AndroidPrintHandler !== "undefined") {
  //     showStatusMessage("🔄 Meng-refresh PWA...", "info");
  //     window.AndroidPrintHandler.refreshPwa();
  //     addDebugLog("PWA refresh command sent");
  //   } else {
  //     showStatusMessage("❌ AndroidPrintHandler tidak tersedia", "error");
  //     addDebugLog("AndroidPrintHandler not available for PWA refresh");
  //   }
  // };

  // const clearCacheAndRefresh = () => {
  //   addDebugLog("Clearing cache and refreshing...");
  //   if (typeof window.AndroidPrintHandler !== "undefined") {
  //     showStatusMessage("🧹 Membersihkan cache dan refresh...", "info");

  //     // Clear localStorage if available
  //     try {
  //       localStorage.clear();
  //       addDebugLog("localStorage cleared");
  //     } catch (e) {
  //       addDebugLog("Error clearing localStorage: " + e.message);
  //     }

  //     // Clear sessionStorage if available
  //     try {
  //       sessionStorage.clear();
  //       addDebugLog("sessionStorage cleared");
  //     } catch (e) {
  //       addDebugLog("Error clearing sessionStorage: " + e.message);
  //     }

  //     // Refresh PWA
  //     window.AndroidPrintHandler.refreshPwa();
  //     addDebugLog("Cache cleared and PWA refresh initiated");
  //   } else {
  //     showStatusMessage("❌ AndroidPrintHandler tidak tersedia", "error");
  //     addDebugLog("AndroidPrintHandler not available for cache clear");
  //   }
  // };

  const testConnection = () => {
    addDebugLog("Testing printer connection...");
    if (typeof window.AndroidPrintHandler !== "undefined") {
      showStatusMessage("🔄 Testing connection...", "info");

      // JSON/ESC-POS test print (GotraApp style)
      const testData = {
        store: {
          name: "KUBER BALI ADVENTURE",
          address: "PAYANGAN, BALI",
          phone: "-",
        },
        transaction: {
          id: "TEST-001",
          date: new Date().toLocaleString("id-ID", {
            dateStyle: "medium",
            timeStyle: "short",
          }),
          cashier: "Admin",
        },
        items: [
          { name: "Printer Connection", qty: 1, price: 0 },
          { name: "Text Alignment", qty: 1, price: 0 },
          { name: "ESC/POS Commands", qty: 1, price: 0 },
          { name: "Raw Data Print", qty: 1, price: 0 },
          { name: "Left-Right Test", qty: 1, price: 0 },
        ],
        payment: {
          subtotal: 0,
          tax: 0,
          total: 0,
          paid: 0,
          change: 0,
        },
        footer: "✅ Semua fungsi aktif\nESC/POS JSON test mode",
      };

      // Detect charsPerLine
      let charsPerLine = 32;
      try {
        if (typeof window.AndroidPrintHandler.getPaperSize === "function") {
          const paperSize = window.AndroidPrintHandler.getPaperSize();
          if (paperSize === "80mm") charsPerLine = 48;
          else if (paperSize === "58mm") charsPerLine = 32;
        }
      } catch (e) {}

      const commands = generatePrintCommandsJson(testData, charsPerLine);

      if (typeof window.AndroidPrintHandler.printJsonData === "function") {
        window.AndroidPrintHandler.printJsonData(JSON.stringify(commands));
        addDebugLog("Test print sent via printJsonData (ESC/POS JSON)");
      } else if (
        typeof window.AndroidPrintHandler.printRawData === "function"
      ) {
        // Fallback to raw ESC/POS string
        const ESC = "\x1B";
        const NEWLINE = "\n";
        const RESET = ESC + "@";
        const CENTER = ESC + "a" + String.fromCharCode(1);
        const LEFT = ESC + "a" + String.fromCharCode(0);
        const RIGHT = ESC + "a" + String.fromCharCode(2);
        const BOLD_ON = ESC + "E" + String.fromCharCode(1);
        const BOLD_OFF = ESC + "E" + String.fromCharCode(0);
        const CUT = ESC + "d" + String.fromCharCode(3);
        const rawContent =
          RESET +
          CENTER +
          BOLD_ON +
          "CONNECTION TEST" +
          BOLD_OFF +
          NEWLINE +
          CENTER +
          "Kuber POS System" +
          NEWLINE +
          CENTER +
          "Date: " +
          new Date().toLocaleDateString("en-US") +
          NEWLINE +
          CENTER +
          "Time: " +
          new Date().toLocaleTimeString("en-US") +
          NEWLINE +
          NEWLINE +
          LEFT +
          BOLD_ON +
          "Test Items:" +
          BOLD_OFF +
          NEWLINE +
          LEFT +
          "Printer Connection" +
          RIGHT +
          "OK" +
          NEWLINE +
          LEFT +
          "Text Alignment" +
          RIGHT +
          "OK" +
          NEWLINE +
          LEFT +
          "ESC/POS Commands" +
          RIGHT +
          "OK" +
          NEWLINE +
          LEFT +
          "Raw Data Print" +
          RIGHT +
          "✅ OK" +
          NEWLINE +
          LEFT +
          "Left-Right Test" +
          RIGHT +
          "✅ PASS" +
          NEWLINE +
          NEWLINE +
          CENTER +
          BOLD_ON +
          "✅ All functions active" +
          BOLD_OFF +
          NEWLINE +
          CENTER +
          "ESC/POS Raw mode ready" +
          NEWLINE +
          CUT;
        window.AndroidPrintHandler.printRawData(rawContent);
        addDebugLog("Test print sent via printRawData (ESC/POS raw)");
      } else if (
        typeof window.AndroidPrintHandler.printHtmlContent === "function"
      ) {
        // Fallback to HTML preview
        const html = `
          <div style="text-align:center;font-size:16px;font-weight:bold;font-family:monospace;">
            <h3>CONNECTION TEST</h3>
            <div>Kuber POS System</div>
            <div>Date: ${new Date().toLocaleDateString("en-US")}</div>
            <div>Time: ${new Date().toLocaleTimeString("en-US")}</div>
            <hr>
            <div style="display:flex;justify-content:space-between;"><span>Printer Connection</span><span>OK</span></div>
            <div style="display:flex;justify-content:space-between;"><span>Text Alignment</span><span>OK</span></div>
            <div style="display:flex;justify-content:space-between;"><span>ESC/POS Commands</span><span>OK</span></div>
            <div style="display:flex;justify-content:space-between;"><span>Raw Data Print</span><span>✅ OK</span></div>
            <div style="display:flex;justify-content:space-between;"><span>Left-Right Test</span><span>✅ PASS</span></div>
            <hr>
            <div>✅ Semua fungsi aktif</div>
            <div>ESC/POS JSON/HTML fallback</div>
          </div>
        `;
        window.AndroidPrintHandler.printHtmlContent(html);
        addDebugLog("Test print sent via printHtmlContent fallback");
      }
    } else {
      showStatusMessage("❌ AndroidPrintHandler tidak tersedia", "error");
      addDebugLog("AndroidPrintHandler not available for test");
    }
  };

  const clearDebugLog = () => {
    setDebugLogs([]);
    setStatusMessages([]);
    addDebugLog("Debug log cleared");
  };

  // API hook untuk create dan update
  const { createData: createProduct } = useCreateData(
    API_URL,
    "transactions"
  );
  const { updateData: updateProduct } = useUpdateData(
    `${API_URL}/${cartItems?.id}`,
    "transactions"
  );

  // Gunakan hook untuk menangani pengiriman form
  const {  isSubmitting } = useSubmitHandler(
    isUpdateMode ? updateProduct : createProduct,
    onSuccess,
    onError
  );

  // Gunakan grandTotal untuk hitung kembalian atau total bayar

  // Load saved bills from localStorage
  useEffect(() => {
    const bills = JSON.parse(localStorage.getItem("savedBills")) || [];
    setSavedBills(bills);

    // Load location dari localStorage
    const savedLocation = localStorage.getItem("cashier_location");
    if (savedLocation) {
      setFormData((prev) => ({
        ...prev,
        location: savedLocation,
      }));
    }

    // Initialize enhanced features
    addDebugLog("CartSummary component loaded");
    checkAndroidHandler();
  }, []);

  // Simpan ke localStorage saat `savedBills` berubah
  useEffect(() => {
    localStorage.setItem("savedBills", JSON.stringify(savedBills));
  }, [savedBills]);

  // 🎯 Setup Event Listeners untuk AndroidPrintHandler
  useEffect(() => {
    const setupEventListeners = () => {
      // Cash drawer events
      const handleCashDrawerSuccess = (event) => {
        addDebugLog(
          "Cash drawer success event: " + (event.detail || "success")
        );
        showStatusMessage("✅ Cash Drawer Berhasil Dibuka!", "success");
      };

      const handleCashDrawerError = (event) => {
        addDebugLog("Cash drawer error event: " + (event.detail || "error"));
        showStatusMessage(
          "❌ Cash Drawer Error: " + (event.detail || "unknown error"),
          "error"
        );
      };

      // Print events
      const handlePrintSuccess = (event) => {
        addDebugLog("Print success event: " + (event.detail || "success"));
        showStatusMessage("✅ Print Berhasil!", "success");
      };

      const handlePrintError = (event) => {
        addDebugLog("Print error event: " + (event.detail || "error"));
        showStatusMessage(
          "❌ Print Error: " + (event.detail || "unknown error"),
          "error"
        );
      };

      // PWA events
      const handlePwaRefreshSuccess = (event) => {
        addDebugLog("PWA refresh success: " + (event.detail || "success"));
        showStatusMessage("✅ PWA berhasil di-refresh!", "success");
      };

      const handlePwaRefreshError = (event) => {
        addDebugLog("PWA refresh error: " + (event.detail || "error"));
        showStatusMessage(
          "❌ PWA refresh error: " + (event.detail || "unknown error"),
          "error"
        );
      };

      // Add event listeners
      window.addEventListener(
        "kuberCashDrawerSuccess",
        handleCashDrawerSuccess
      );
      window.addEventListener("kuberCashDrawerError", handleCashDrawerError);
      window.addEventListener("kuberPrintSuccess", handlePrintSuccess);
      window.addEventListener("kuberPrintError", handlePrintError);
      window.addEventListener(
        "kuberPwaRefreshSuccess",
        handlePwaRefreshSuccess
      );
      window.addEventListener("kuberPwaRefreshError", handlePwaRefreshError);

      // Legacy events support (GotraApp compatibility)
      window.addEventListener(
        "gotraCashDrawerSuccess",
        handleCashDrawerSuccess
      );
      window.addEventListener("gotraCashDrawerError", handleCashDrawerError);
      window.addEventListener("gotraPrintSuccess", handlePrintSuccess);
      window.addEventListener("gotraPrintError", handlePrintError);
      window.addEventListener(
        "gotraPwaRefreshSuccess",
        handlePwaRefreshSuccess
      );
      window.addEventListener("gotraPwaRefreshError", handlePwaRefreshError);
      window.addEventListener("cashDrawerSuccess", handleCashDrawerSuccess);
      window.addEventListener("cashDrawerError", handleCashDrawerError);

      // Cleanup function
      return () => {
        window.removeEventListener(
          "kuberCashDrawerSuccess",
          handleCashDrawerSuccess
        );
        window.removeEventListener(
          "kuberCashDrawerError",
          handleCashDrawerError
        );
        window.removeEventListener("kuberPrintSuccess", handlePrintSuccess);
        window.removeEventListener("kuberPrintError", handlePrintError);
        window.removeEventListener(
          "kuberPwaRefreshSuccess",
          handlePwaRefreshSuccess
        );
        window.removeEventListener(
          "kuberPwaRefreshError",
          handlePwaRefreshError
        );

        // Legacy cleanup
        window.removeEventListener(
          "gotraCashDrawerSuccess",
          handleCashDrawerSuccess
        );
        window.removeEventListener(
          "gotraCashDrawerError",
          handleCashDrawerError
        );
        window.removeEventListener("gotraPrintSuccess", handlePrintSuccess);
        window.removeEventListener("gotraPrintError", handlePrintError);
        window.removeEventListener(
          "gotraPwaRefreshSuccess",
          handlePwaRefreshSuccess
        );
        window.removeEventListener(
          "gotraPwaRefreshError",
          handlePwaRefreshError
        );
        window.removeEventListener(
          "cashDrawerSuccess",
          handleCashDrawerSuccess
        );
        window.removeEventListener("cashDrawerError", handleCashDrawerError);
      };
    };

    const cleanup = setupEventListeners();
    return cleanup;
  }, []);

  // Auto-check AndroidHandler status every 10 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      checkAndroidHandler();
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (paymentMethod === "Cash") {
      const cash = parseInt(cashPaid, 10) || 0;
      setChange(cash - grandTotal); // ✅ sudah termasuk pajak
    }
  }, [cashPaid, grandTotal, paymentMethod]);
  // Hitung kembalian atau kekurangan saat uang dibayarkan berubah
  // useEffect(() => {
  //   if (paymentMethod === "Cash") {
  //     const cash = parseInt(cashPaid, 10) || 0;
  //     setChange(cash - totalPrice);
  //   }
  // }, [cashPaid, totalPrice, paymentMethod]);

  // Function untuk menampilkan Swal
  const showSwal = (icon, title, text = "", timer = 2000) => {
    Swal.fire({
      toast: true,
      position: "top-end",
      icon,
      title,
      text,
      timer,
      showConfirmButton: false,
      timerProgressBar: true,
    });
  };

  // Update jumlah item di cart
  const updateQuantity = (productId, newQuantity) => {
    setCart((prevCart) =>
      prevCart
        .map((item) =>
          item.id === productId ? { ...item, quantity: newQuantity } : item
        )
        .filter((item) => item.quantity > 0)
    );
  };

  // Hapus satu item dari cart
  const removeItem = (productId) => {
    setCart((prevCart) => prevCart.filter((item) => item.id !== productId));
  };

  // Hapus semua item dari cart
  const clearCart = () => setCart([]);

  // Simpan bill ke localStorage
  const saveBill = () => {
    if (cartItems.length === 0)
      return showSwal("error", "Tidak ada item di bill");

    const billData = {
      id: Date.now(),
      date: new Date().toLocaleString(),
      items: cartItems,
      total: cartItems.reduce(
        (total, item) => total + item.price * item.quantity,
        0
      ),
    };

    setSavedBills([...savedBills, billData]);
    showSwal("success", "Bill berhasil disimpan");
    clearCart();
  };

  // Load bill ke cart
  const loadBillToCart = (bill) => {
    if (cartItems.length > 0) {
      Swal.fire({
        title: "Ganti Bill?",
        text: "Bill yang sedang aktif akan diganti.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya, Ganti!",
        cancelButtonText: "Batal",
      }).then((result) => {
        if (result.isConfirmed) {
          setCart(bill.items);
          setActiveBillId(bill.id);
          showSwal("success", "Bill berhasil dimuat!");
        }
      });
    } else {
      setCart(bill.items);
      setActiveBillId(bill.id);
      showSwal("success", "Bill berhasil dimuat!");
    }
  };

  // const totalPrice = cartItems.reduce(
  //   (total, item) => total + item.price * item.quantity,
  //   0
  // );

  // Hapus bill dari daftar
  const deleteBill = (billId) => {
    setSavedBills(savedBills.filter((bill) => bill.id !== billId));
  };

  // Generate JSON data for receipt (GotraApp style)
  const buildReceiptJson = (
    bill,
    cashPaid,
    change,
    paymentMethod
  ) => {
    const subtotal = (bill.items || []).reduce(
      (sum, item) => sum + item.price * item.quantity,
      0
    );
    const productTaxAmount = (bill.items || []).reduce(
      (sum, item) => sum + (item.price * item.quantity * (parseFloat(item.tax_percent || 0) / 100)),
      0
    );
    // Kita perlu meneruskan taxRate ke buildReceiptJson jika ingin menghitung ulang payment tax di sini
    // Namun untuk sementara kita asumsikan taxRate tersedia atau diteruskan
    // Dihitung dari (Subtotal + Pajak Produk)
    const paymentTaxAmount = (subtotal + productTaxAmount) * taxRate; 
    const total = subtotal + productTaxAmount + paymentTaxAmount;
    return {
      store: {
        name: "KUBER Adventure & Tours",
        address: "Bali, Indonesia",
        phone: "-",
      },
      transaction: {
        id: bill.code || "-",
        date: new Date().toLocaleString("id-ID", {
          dateStyle: "medium",
          timeStyle: "short",
        }),
        cashier: "Admin",
      },
      items: (bill.items || []).map((item) => ({
        name: item.name,
        qty: item.quantity,
        price: item.price,
        tax_percent: item.tax_percent,
      })),
      payment: {
        subtotal,
        productTax: productTaxAmount,
        paymentTax: paymentTaxAmount,
        total,
        paid: parseInt(cashPaid, 10) || 0,
        change: change || 0,
        paymentTaxRate: taxRate * 100,
      },
      // footer: "Terima kasih atas kunjungan Anda!\nwww.kuberbaliadventure.com", gunakan bahasa inggris untuk footer
      footer: "Thank you for visiting us!\nwww.kuberbaliadventure.com",
      payment_method: paymentMethod || "Cash",
    };
  };

  // Generate ESC/POS JSON commands for AndroidPrintHandler.printJsonData
  const generatePrintCommandsJson = (data, charsPerLine = 32) => {
    const commands = [];
    const separator = "- ".repeat(Math.floor(charsPerLine / 2));
    // Add logo image (if available and valid base64 PNG)
    if (
      KUBER_LOGO_BASE64 &&
      typeof KUBER_LOGO_BASE64 === "string" &&
      KUBER_LOGO_BASE64.length > 100
    ) {
      // Only send the base64 string, not the data:image/png;base64, prefix
      let base64 = KUBER_LOGO_BASE64;
      if (base64.startsWith("data:image")) {
        const parts = base64.split(",");
        if (parts.length === 2) base64 = parts[1];
      }
      // Set width to half of previous (192px for 58mm, 256px for 80mm)
      const logoWidth = charsPerLine === 48 ? 256 : 192;
      commands.push({
        type: "image",
        value: base64,
        align: "center",
        width: logoWidth,
        format: "base64",
      });
      commands.push({ type: "line_break" });
    }
    // Store Info (Header)
    commands.push({
      type: "text",
      value: data.store.name.toUpperCase(),
      align: "center",
      font: "bold",
      size: "normal",
    });
    commands.push({ type: "text", value: data.store.address, align: "center" });
    if (data.store.phone && data.store.phone !== "-") {
      commands.push({
        type: "text",
        value: `TEL: ${data.store.phone}`,
        align: "center",
      });
    }
    commands.push({ type: "line_break" });
    commands.push({ type: "text", value: separator, align: "center" });
    commands.push({ type: "line_break" });
    // Transaction Info
    commands.push({
      type: "text",
      value: `INVOICE: ${data.transaction.id}`,
      align: "left",
    });
    commands.push({
      type: "text",
      value: `CASHIER: ${data.transaction.cashier} ${data.transaction.date}`,
      align: "left",
    });
    commands.push({ type: "line_break" });
    commands.push({ type: "text", value: separator, align: "center" });
    commands.push({ type: "line_break" });
    // Items
    data.items.forEach((item) => {
      const itemText = `(${item.qty}x) ${item.name}`;
      const itemPriceFormatted = `Rp ${(item.qty * item.price).toLocaleString(
        "id-ID"
      )}`;
      // Jika nama item terlalu panjang, tampilkan di bawah, harga tetap di kanan
      if (itemText.length + itemPriceFormatted.length > charsPerLine) {
        // Baris pertama: nama item (full, kiri)
        commands.push({ type: "text", value: itemText, align: "left" });
        // Baris kedua: harga, kanan
        commands.push({
          type: "text",
          value: itemPriceFormatted,
          align: "right",
        });
      } else {
        // Baris satu: nama item + harga, harga tetap kanan
        const padding =
          charsPerLine - itemText.length - itemPriceFormatted.length;
        const finalLine = `${itemText}${" ".repeat(
          Math.max(0, padding)
        )}${itemPriceFormatted}`;
        commands.push({ type: "text", value: finalLine, align: "left" });
      }
    });
    commands.push({ type: "line_break" });
    commands.push({ type: "text", value: separator, align: "center" });
    commands.push({ type: "line_break" });
    // Payment Info
    // Payment Method

    commands.push({
      type: "text",
      value: `SUBTOTAL: Rp ${data.payment.subtotal.toLocaleString("id-ID")}`,
      align: "right",
    });
    commands.push({
      type: "text",
      value: `ppn/tax : Rp ${data.payment.productTax.toLocaleString("id-ID")}`,
      align: "right",
    });
    if (data.payment.paymentTax > 0) {
      commands.push({
        type: "text",
        value: `${data.payment_method.toLowerCase()} ${data.payment.paymentTaxRate}% : Rp ${data.payment.paymentTax.toLocaleString("id-ID")}`,
        align: "right",
      });
    }
    commands.push({
      type: "text",
      value: `TOTAL: Rp ${data.payment.total.toLocaleString("id-ID")}`,
      align: "right",
      font: "bold",
      size: "normal",
    });
    commands.push({ type: "line_break" });
    commands.push({ type: "text", value: separator, align: "center" });
    commands.push({ type: "line_break" });
    // Payment Details
    commands.push({
      type: "text",
      value: `PAYMENT METHOD: ${data.payment_method}`,
      align: "right",
    });
    commands.push({
      type: "text",
      value: `PAID: Rp ${data.payment.paid.toLocaleString("id-ID")}`,
      align: "right",
    });
    commands.push({
      type: "text",
      value: `CHANGE: Rp ${data.payment.change.toLocaleString("id-ID")}`,
      align: "right",
    });
    commands.push({ type: "line_break" });
    commands.push({ type: "text", value: separator, align: "center" });
    commands.push({ type: "line_break" });
    // Footer
    data.footer.split("\n").forEach((line) => {
      commands.push({ type: "text", value: line, align: "center" });
    });
    commands.push({ type: "line_break" });
    commands.push({ type: "line_break" });
    commands.push({ type: "cut" });
    return { commands };
  };

  // Main printReceipt function using GotraApp JSON/ESC-POS approach
  const printReceipt = (bill, cashPaid, change, paymentMethod, taxRate = 0) => {
    const receiptData = buildReceiptJson(
      bill,
      cashPaid,
      change,
      paymentMethod
    );
    // Default charsPerLine: 32 (58mm) or 48 (80mm)
    let charsPerLine = 32;
    try {
      if (
        typeof window.AndroidPrintHandler !== "undefined" &&
        typeof window.AndroidPrintHandler.getPaperSize === "function"
      ) {
        const paperSize = window.AndroidPrintHandler.getPaperSize();
        if (paperSize === "80mm") charsPerLine = 48;
        else if (paperSize === "58mm") charsPerLine = 32;
      }
    } catch (e) {
      // fallback to 32
    }
    const printCommands = generatePrintCommandsJson(receiptData, charsPerLine);

    if (
      typeof window.AndroidPrintHandler !== "undefined" &&
      typeof window.AndroidPrintHandler.printJsonData === "function"
    ) {
      addDebugLog("Printing receipt with AndroidPrintHandler.printJsonData...");
      showStatusMessage("🖨️ Printing receipt...", "info");
      window.AndroidPrintHandler.printJsonData(JSON.stringify(printCommands));
      addDebugLog("Receipt sent to AndroidPrintHandler.printJsonData");
    } else {
      // Fallback to HTML print preview (for browser)
      addDebugLog("Printing receipt with printJS fallback...");
      showStatusMessage("🖨️ Printing receipt (fallback)...", "info");
      // const itemsHtml = receiptData.items
      //   .map(
      //     (item) =>
      //       `<div style=\"display:flex;justify-content:space-between;\"><span>${
      //         item.name
      //       } (${item.qty}x)</span><span>Rp ${(
      //         item.qty * item.price
      //       ).toLocaleString("id-ID")}</span></div>`
      //   )
      //   .join("");
      const itemsHtml = receiptData.items
        .map(
          (item) =>
            `<div style="display:flex;justify-content:space-between;margin-bottom:3px;">
        <span style="font-weight:bold;">${item.name} (${item.qty}x)</span>
        <span>Rp ${(item.qty * item.price).toLocaleString("id-ID")}</span>
      </div>`
        )
        .join("");
      const receiptHtml = `
        <div style=\"text-align:center;font-size:16px;font-weight:bold;font-family:monospace;\">
          <div style=\"margin-bottom:1px;\">
            <img src=\"data:image/png;base64,${KUBER_LOGO_BASE64}\" style=\"width:120px;height:auto;margin-bottom:10px;\" alt=\"Kuber Logo\" />
          </div>
          <div style=\"margin-bottom:5px;\">
            <strong style=\"font-size:18px;\">${
              receiptData.store.name
            }</strong><br>
            <span style=\"font-size:12px;\">${receiptData.store.address}</span>
          </div>
          <h3>SALES RECEIPT</h3>
          <strong>Kuber POS System</strong><br>
          Invoice: ${receiptData.transaction.id} <br/>
          Date: ${receiptData.transaction.date}<br/>
          <p>Cashier: ${receiptData.transaction.cashier}</p>
        </div>
        <hr>
        ${itemsHtml}
        <hr>
        <div style=\"display:flex;justify-content:space-between;margin-bottom:3px;\">
          <span>Subtotal:</span>
          <span>Rp ${receiptData.payment.subtotal.toLocaleString("id-ID")}</span>
        </div>
        <div style="display:flex;justify-content:space-between;margin-bottom:3px;">
          <span>ppn/tax :</span>
          <span>Rp ${receiptData.payment.productTax.toLocaleString("id-ID")}</span>
        </div>
        ${
          receiptData.payment.paymentTax > 0
            ? `<div style="display:flex;justify-content:space-between;margin-bottom:3px;">
          <span>${receiptData.payment_method.toLowerCase()} ${receiptData.payment.paymentTaxRate}% :</span>
          <span>Rp ${receiptData.payment.paymentTax.toLocaleString("id-ID")}</span>
        </div>`
            : ""
        }
        <div style=\"display:flex;justify-content:space-between;margin-bottom:3px;\"><strong>Total:</strong><strong>Rp ${receiptData.payment.total.toLocaleString(
          "id-ID"
        )}</strong></div>
        <div style=\"display:flex;justify-content:space-between;margin-bottom:3px;\"><span>Bayar:</span><span>Rp ${receiptData.payment.paid.toLocaleString(
          "id-ID"
        )}</span></div>
        <div style=\"display:flex;justify-content:space-between;margin-bottom:3px;\"><span>Kembali:</span><span>Rp ${receiptData.payment.change.toLocaleString(
          "id-ID"
        )}</span></div>
        <hr>
        <div style=\"text-align:center;\">
          <p>${receiptData.footer.replace(/\n/g, "<br>")}</p>
        </div>
      `;
      printJS({
        printable: receiptHtml,
        type: "raw-html",
        style: `
          @page { size: 80mm auto; margin: 3mm; }
          body { font-family: 'Courier New', monospace; font-size: 11px; line-height: 1.3; width: 74mm; margin: 0; padding: 0; }
          .receipt-preview .center { text-align: center; }
          .receipt-preview .right { text-align: right; }
          .receipt-preview hr { border: none; border-top: 1px dashed #333; margin: 10px 0; }
          .flex-row { display: flex; justify-content: space-between; margin-bottom: 2px; }
          .flex-row span:first-child { text-align: left; }
          .flex-row span:last-child { text-align: right; }
        `,
      });
      addDebugLog("Receipt printed with printJS");
    }

    // Open cash drawer after printing (only for Cash payments, after last print)
    if (paymentMethod === "Cash") {
      setTimeout(() => {
        openCashDrawer();
        addDebugLog("Cash drawer opened after successful cash payment");
        showStatusMessage(
          "💰 Cash transaction completed - Cash drawer opened!",
          "success"
        );
      }, 3000);
    } else {
      setTimeout(() => {
        addDebugLog(
          `${paymentMethod} payment completed - No cash drawer action needed`
        );
        showStatusMessage(
          `✅ ${paymentMethod} transaction completed successfully!`,
          "success"
        );
      }, 3000);
    }
  };

  const handlePayment = async () => {
    addDebugLog("Starting payment process...");

    if (cartItems.length === 0) {
      showStatusMessage("❌ Bill masih kosong!", "error");
      return alert("Bill masih kosong!");
    }
    if (!paymentMethod) {
      showStatusMessage("❌ Pilih metode pembayaran!", "error");
      return alert("Pilih metode pembayaran!");
    }
    if (paymentMethod === "Cash" && change < 0) {
      showStatusMessage(
        `❌ Uang tidak cukup! Kurang Rp ${Math.abs(change).toLocaleString()}`,
        "error"
      );
      return Swal.fire({
        icon: "error",
        title: "Uang tidak cukup!",
        text: `Kurang Rp ${Math.abs(change).toLocaleString()}`,
        confirmButtonText: "OK",
      });
    }

    addDebugLog(
      `Payment method: ${paymentMethod}, Cash paid: ${cashPaid}, Change: ${change}`
    );
    showStatusMessage("🔄 Memproses pembayaran...", "info");

    const payload = {
      payment_method_id: paymentMethods.data.find(
        (p) => p.name === paymentMethod
      )?.id,
      notes: formData.notes || "",
      location: formData.location || "",
      total_price: subtotal.toString(),
      tax: (productTaxAmount + paymentTaxAmount).toString(),
      grand_total: grandTotal.toString(),
      tax_percent: (subtotal > 0 ? ((productTaxAmount + paymentTaxAmount) / subtotal * 100).toFixed(1) : "0"),
      items: cartItems.map((item) => {
        const itemTaxPercent = parseFloat(item.tax_percent || 0);
        const itemTaxAmount = (item.price * item.quantity * itemTaxPercent) / 100;
        return {
          menu_id: item.id,
          item_name: item.name || "",
          price: item.price.toString(),
          quantity: item.quantity.toString(),
          tax_percent: itemTaxPercent.toString(),
          tax_amount: itemTaxAmount.toString(),
        };
      }),
    };

    try {
      addDebugLog("Sending transaction to server...");
      const response = await createProduct(payload);

      addDebugLog("Transaction saved successfully");
      showStatusMessage("✅ Transaksi Berhasil Disimpan!", "success");
      showSwal("success", "Transaksi Berhasil Disimpan!");

      const transaction = response?.data?.data;

      onSuccess();
      closeModal();

      addDebugLog("Printing receipt...");
      printReceipt(
        {
          ...transaction,
          items:
            transaction?.transaction_items?.map((t) => ({
              name: t.item_name,
              quantity: parseFloat(t.quantity || 0),
              price: parseFloat(t.price || 0),
              tax_percent: parseFloat(t.tax_percent || 0),
            })) || [],
        },
        cashPaid,
        change,
        paymentMethod,
        taxRate
      );
    } catch (error) {
      console.error("Error saving transaction:", error);
      const errorMessage = error?.response?.data?.message || error.message;
      addDebugLog("Transaction error: " + errorMessage);
      showStatusMessage(
        "❌ Gagal Menyimpan Transaksi: " + errorMessage,
        "error"
      );
      showSwal("error", "Gagal Menyimpan Transaksi", errorMessage);
      return;
    }

    addDebugLog("Payment completed successfully");
    setCashPaid("");
    setChange(null);
    setCart([]);
  };

  // Tampilkan modal pembayaran
  const showPaymentModal = () => setShowModal(true);

  // Tutup modal

  return (
    <div className="p-3 border-start bg-info-lt" style={{ width: "350px" }}>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <div>
          <h4>Bill</h4>
          {formData.location && (
            <small className="text-muted d-flex align-items-center">
              {formData.location === "bar" && (
                <span role="img" aria-label="Bar" className="me-1">
                  🍸
                </span>
              )}
              {formData.location === "coffee_shop" && (
                <span role="img" aria-label="Coffee" className="me-1">
                  ☕
                </span>
              )}
              {formData.location === "merchandise" && (
                <span role="img" aria-label="Merchandise" className="me-1">
                  🛍️
                </span>
              )}
              {formData.location === "bar" && "Bar"}
              {formData.location === "coffee_shop" && "Coffee Shop"}
              {formData.location === "merchandise" && "Merchandise"}
            </small>
          )}
        </div>
        <PermissionMiddleware allowedRoles={["superadmin"]}>
          <div className="d-flex align-items-center gap-2">
            {/* AndroidHandler Status */}
            <Badge
              bg={androidHandlerStatus ? "success" : "danger"}
              className="d-flex align-items-center gap-1"
            >
              <IconPrinter size={14} />
              {androidHandlerStatus ? "Online" : "Offline"}
            </Badge>

            {/* Debug Toggle */}
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() => setShowDebugLog(!showDebugLog)}
              title="Toggle Debug Log"
            >
              <IconBugOff size={16} />
            </Button>
          </div>
        </PermissionMiddleware>
      </div>

      {/* 🎯 Status Messages */}
      {statusMessages.length > 0 && (
        <div className="mb-2">
          {statusMessages.map((message) => (
            <Alert
              key={message.id}
              variant={
                message.type === "success"
                  ? "success"
                  : message.type === "error"
                  ? "danger"
                  : message.type === "warning"
                  ? "warning"
                  : "info"
              }
              className="py-2 px-3 mb-1"
              style={{ fontSize: "12px" }}
            >
              <div className="d-flex justify-content-between align-items-center">
                <span>{message.message}</span>
                <small className="text-muted">{message.timestamp}</small>
              </div>
            </Alert>
          ))}
        </div>
      )}

      {/* 🎯 Enhanced Controls */}
      {/* {androidHandlerStatus && ( */}
      <div className="mb-2">
        <div className="row g-1">
          <div className="col-6">
            <Button
              variant="outline-info"
              size="sm"
              className="w-100"
              onClick={testConnection}
              title="Test Printer Connection"
            >
              <IconPrinter size={14} />
            </Button>
          </div>
          <div className="col-6">
            <Button
              variant="outline-success"
              size="sm"
              className="w-100"
              onClick={openCashDrawer}
              title="Open Cash Drawer"
            >
              <IconCash size={14} />
            </Button>
          </div>
          {/* <div className="col-3">
              <Button
                variant="outline-primary"
                size="sm"
                className="w-100"
                onClick={refreshPwa}
                title="Refresh PWA"
              >
                <IconRefresh size={14} />
              </Button>
            </div>
            <div className="col-3">
              <Button
                variant="outline-warning"
                size="sm"
                className="w-100"
                onClick={clearCacheAndRefresh}
                title="Clear Cache"
              >
                <IconBugOff size={14} />
              </Button>
            </div> */}
        </div>
      </div>
      {/* )} */}

      <div className="flex-grow-1 overflow-auto" style={{ maxHeight: "60vh" }}>
        {cartItems.length === 0 ? (
          <p className="text-muted text-center">Belum ada item di bill </p>
        ) : (
          <>
            <div className="card">
              <div className="card-body p-1">
                <ul className="list-group list-group-flush">
                  {cartItems.map((item) => (
                    <li key={item.id} className="list-group-item">
                      <div className="d-flex justify-content-between">
                        <div>
                          <strong>{item.name}</strong>
                        </div>
                        <span className="text-muted">
                          {/* Rp {item.price.toLocaleString()} */}
                          {/* gunakan formatPrice */}
                          {formatPrice(item.price)}
                        </span>
                      </div>

                      {/* Tombol Update Quantity */}
                      <div className="d-flex justify-content-between align-items-center mt-2">
                        <div className="btn-group align-items-center">
                          <button
                            className="btn btn-sm btn-outline-instagram"
                            onClick={() =>
                              updateQuantity(item.id, item.quantity - 1)
                            }
                          >
                            <IconMinus size={18} />
                          </button>
                          <span className="mx-2">{item.quantity}</span>
                          <button
                            className="btn btn-sm btn-outline-teal"
                            onClick={() =>
                              updateQuantity(item.id, item.quantity + 1)
                            }
                          >
                            <IconPlus size={18} />
                          </button>
                        </div>
                        <button
                          className="btn btn-sm btn-instagram"
                          onClick={() => removeItem(item.id)}
                        >
                          <IconTrash size={18} />
                        </button>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </>
        )}
      </div>
      {/* Tombol tetap di bawah */}
      <div className="mt-2">
        {/* Total Harga */}
        <div className="mt-3 border-top pt-2">
          <h3 className="text-end">
            Sub Total Before TAX: Rp{" "}
            {cartItems
              .reduce((total, item) => total + item.price * item.quantity, 0)
              .toLocaleString()}
          </h3>
        </div>

        {/* Tombol Pembayaran */}
        <button
          className="btn btn-lg btn-success w-100 mt-3"
          onClick={showPaymentModal} // Menampilkan modal
        >
          PAY NOW
        </button>

        <div className="row g-2 mt-2">
          <div className="col-4">
            <button
              className="btn btn-outline-danger w-100"
              onClick={clearCart}
            >
              <IconTrash size={18} /> Clear
            </button>
          </div>
          <div className="col-4">
            <button
              className="btn btn-outline-success w-100"
              onClick={saveBill}
            >
              <IconDeviceFloppy size={18} /> Save
            </button>
          </div>
          <div className="col-4">
            <button
              className="btn btn-outline-primary w-100"
              data-bs-toggle="offcanvas"
              data-bs-target="#savedBillsOffcanvas"
            >
              <IconGardenCart size={18} /> Load
            </button>
          </div>
        </div>

        {/* 🎯 Debug Log Panel */}
        {showDebugLog && (
          <div className="mt-3">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h6 className="mb-0">📝 Debug Log</h6>
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={clearDebugLog}
              >
                Clear
              </Button>
            </div>
            <div
              className="border rounded p-2"
              style={{
                backgroundColor: "#000",
                color: "#00ff00",
                fontFamily: "monospace",
                fontSize: "11px",
                height: "150px",
                overflowY: "auto",
              }}
            >
              {debugLogs.length === 0 ? (
                <div className="text-muted">No debug logs yet...</div>
              ) : (
                debugLogs.map((log, index) => <div key={index}>{log}</div>)
              )}
            </div>
          </div>
        )}
      </div>

      {/* OFFCANVAS UNTUK MELIHAT BILL TERSIMPAN */}
      <div
        className="offcanvas offcanvas-end"
        tabIndex="-1"
        id="savedBillsOffcanvas"
        aria-labelledby="savedBillsLabel"
      >
        <div className="offcanvas-header">
          <h5 id="savedBillsLabel">Saved Bills</h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body">
          {savedBills.length === 0 ? (
            <p className="text-muted">Tidak ada bill yang tersimpan.</p>
          ) : (
            <ul className="list-group">
              {savedBills.map((bill) => (
                <li
                  key={bill.id}
                  className="list-group-item d-flex justify-content-between align-items-center"
                  style={{ cursor: "pointer" }}
                  onClick={() => loadBillToCart(bill)} // ✅ Klik untuk memuat bill ke cart
                >
                  <div>
                    <strong>Bill ID:</strong> {bill.id} <br />
                    <strong>Date:</strong> {bill.date} <br />
                    <strong>Total:</strong> Rp {bill.total.toLocaleString()}
                  </div>
                  <div className="btn-group">
                    <button
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => deleteBill(bill.id)}
                    >
                      Hapus
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
      {/* modal */}
      <Modal show={showModal} onHide={closeModal} className="modal-lg">
        <Modal.Header closeButton>
          <Modal.Title className="d-flex align-items-center gap-2">
            💰 Pembayaran
            {androidHandlerStatus && (
              <Badge bg="success" className="d-flex align-items-center gap-1">
                <IconPrinter size={14} />
                Hardware Ready
              </Badge>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Detail Item dan Total Biaya */}
          <div className="mb-3">
            <h5>Detail Pembayaran</h5>
            {/* print json cartItems*/}
            {/* <pre>{JSON.stringify(cartItems, null, 2)}</pre> */}
            <div className="table-responsive">
              <table className="table table-sm table-striped table-bordered">
                <thead>
                  <tr>
                    <th>Item</th>
                    <th>Qty</th>
                    <th className="text-end">Harga</th>
                    <th className="text-center">Tax (%)</th>
                    <th className="text-end">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {cartItems.map((item, index) => (
                    <tr key={index}>
                      <td>{item.name}</td>
                      <td>{item.quantity}</td>
                      <td className="text-end">
                        {formatPrice(item.price)}
                      </td>
                      <td className="text-center">
                        {item.tax_percent > 0 ? (
                          <span className="badge bg-red-lt">{item.tax_percent}%</span>
                        ) : (
                          <span className="text-muted">0%</span>
                        )}
                      </td>
                      <td className="text-end">
                        Rp {(item.price * item.quantity).toLocaleString()}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* <div className="mt-2">
            <h1 className="text-end">
              Total: Rp {totalPrice.toLocaleString()}
            </h1>
          </div> */}
          {/* Total dengan Pajak */}
          <div className="mt-3">
            <table className="table table-sm mb-3">
              <tbody>
                {/* <div>
                  <p>Subtotal: Rp {subtotal.toLocaleString()}</p>
                  <p>
                    Tax ({(taxRate * 100).toFixed(2)}%): Rp{" "}
                    {taxAmount.toLocaleString()}
                  </p>
                  <p>Total: Rp {grandTotal.toLocaleString()}</p>
                </div> */}

                <tr>
                  <td className="text-start">Subtotal</td>
                  <td className="text-end">
                    <strong>Rp {subtotal.toLocaleString()}</strong>
                  </td>
                </tr>
                <tr>
                  <td className="text-start">Tax (Produk)</td>
                  <td className="text-end">
                    <strong>Rp {productTaxAmount.toLocaleString()}</strong>
                  </td>
                </tr>
                {paymentTaxAmount > 0 && (
                  <tr>
                    <td className="text-start">
                      Tax/Fee ({paymentMethod} {(taxRate * 100).toFixed(2)}%)
                    </td>
                    <td className="text-end">
                      <strong>Rp {paymentTaxAmount.toLocaleString()}</strong>
                    </td>
                  </tr>
                )}
                <tr>
                  <td className="text-start">Total Setelah Pajak</td>
                  <td className="text-end text-primary fw-bold">
                    <strong>Rp {grandTotal.toLocaleString()}</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {paymentMethod === "Cash" && (
            <Form.Group className="mb-3">
              <Form.Label>Masukkan Uang:</Form.Label>
              <Form.Control
                type="number"
                placeholder="Masukkan jumlah uang"
                value={cashPaid}
                onChange={(e) => setCashPaid(e.target.value)}
                min={1}
              />
              {cashPaid && (
                <h1
                  className={`mt-2 text-end f-1 fw-bold ${
                    change < 0 ? "text-danger" : "text-success"
                  }`}
                >
                  {change < 0
                    ? `Kurang Rp ${Math.abs(change).toLocaleString()}`
                    : `Kembalian Rp ${change.toLocaleString()}`}
                </h1>
              )}
            </Form.Group>
          )}
          {/* Pilih Metode Pembayaran */}
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Pilih Metode Pembayaran</Form.Label>
              {/* paymentMethods mapping untuk btn */}
              <div className="gap-2">
                {filteredPaymentMethods.map((method) => (
                  <Button
                    key={method.id}
                    variant={
                      paymentMethod === method.name
                        ? "success"
                        : "outline-success"
                    }
                    onClick={() => setPaymentMethod(method.name)}
                    className="flex-fill m-1"
                  >
                    {method.name}
                  </Button>
                ))}
              </div>
            </Form.Group>
          </Form>
          {/* notes */}
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Notes:</Form.Label>
              <Form.Control
                type="textarea"
                placeholder="Masukkan catatan"
                value={formData.notes}
                onChange={(e) =>
                  setFormData((prev) => ({ ...prev, notes: e.target.value }))
                }
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-between align-items-center w-100">
            <div className="d-flex gap-2">
              {/* Test Controls (hanya tampil jika AndroidHandler tersedia) */}
              {androidHandlerStatus && (
                <>
                  <Button
                    variant="outline-info"
                    size="sm"
                    onClick={testConnection}
                    title="Test Printer"
                  >
                    <IconPrinter size={16} /> Test
                  </Button>
                  <Button
                    variant="outline-success"
                    size="sm"
                    onClick={openCashDrawer}
                    title="Open Cash Drawer"
                  >
                    <IconCash size={16} /> Drawer
                  </Button>
                </>
              )}
            </div>

            <div className="d-flex gap-2">
              <Button variant="secondary" onClick={closeModal}>
                Cancel
              </Button>
              <Button
                variant="primary"
                onClick={handlePayment}
                disabled={isSubmitting}
                className="d-flex align-items-center gap-2"
              >
                {isSubmitting ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Processing...
                  </>
                ) : (
                  <>
                    <IconPrinter size={16} />
                    Save & Print
                  </>
                )}
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CartSummary;
